export default class ChatSettings {
    public apiUrl: string;
    public hubUrl: string;
    constructor(settings: any) {
        this.apiUrl = settings.url;
        this.hubUrl = settings.hub;
    }
}